import { render } from "./PositionView.vue?vue&type=template&id=20861fc9&scoped=true"
import script from "./PositionView.vue?vue&type=script&lang=js"
export * from "./PositionView.vue?vue&type=script&lang=js"

import "./PositionView.vue?vue&type=style&index=0&id=20861fc9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20861fc9"]])

export default __exports__